"use client"

import { footerLogo } from '@/assets/imgs'
import { AiOutlineClockCircle, AiOutlineMail } from 'react-icons/ai'
import { BiPhoneCall } from 'react-icons/bi'
import { GoLocation } from 'react-icons/go'
import Link from 'next/link'
import { useServicesLinks } from '../Nav/links'
import { Socials } from '../Social/Social'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

type info = {
  Icon: React.FC<{ className?: string }>
  url?: string
  content: string
}

const contactInfo = (t: ReturnType<typeof useTranslations>): info[] => [
  {
    Icon: GoLocation,
    content:`${t('contactInfo.location')}\n${t('contactInfo.buildingNumber')}\n${t('contactInfo.officeNumber')}`,
  },
  {
    Icon: BiPhoneCall,
    content: t('contactInfo.number'),
    url: 'tel:+963987233122',
  },
  {
    Icon: AiOutlineMail,
    content: t('contactInfo.companyEmail'),
    url: 'mailto:info@codehorizon.org',
  },
  {
    Icon: AiOutlineClockCircle,
    content: t('contactInfo.openingHours'),
  },
]

const FooterContent = () => {
  const t = useTranslations()
  const servicesLinks = useServicesLinks()

  return (
    <div className='grid grid-cols-3 gap-6 px-6 pt-20 pb-10 sm:px-14 md:px-16 lg:justify-items-center lg:bg-position-[left_calc(40%)_top_calc(0%)]'>
      <div className='col-span-3 flex flex-col lg:col-span-1'>
        <Image alt='footer' src={footerLogo} className='w-44' />
        <p className='my-7'>{t('footer.content')}</p>
        <div className='mb-5 lg:mb-0'>
          <Socials
          className='flex gap-2 sm:gap-5 items-center'
            render={(link, index) => (
              <li
                key={index}
                className='rounded-full bg-white transition-all hover:bg-primary hover:text-white'
              >
                <a href={link.url} aria-label='social-link' target='_blank' className='transition-all'>
                  <link.icon className='m-3 w-5 h-5' />
                </a>
              </li>
            )}
          />
        </div>
      </div>

      <div className='col-span-3 lg:col-span-1'>
        <p className='mb-8 text-xl font-semibold'>
          {t('footer.ITServices')}
        </p>
        <ul className='w-fit'>
          {servicesLinks.map((link, index) => (
            <li className='mb-3 hover:text-secondary' key={index}>
              <Link href={link.url}>{link.title}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div className='col-span-3 lg:col-span-1'>
        <p className='mb-8 text-xl font-semibold'>
          {t('links.contactUs')}
        </p>
        <ul className='flex flex-col gap-4'>
          {contactInfo(t).map((info, index) => (
            <li aria-label='content' key={index} className='flex items-center gap-3'>
              <info.Icon className='h-8 w-7 self-start' />
              {info.url ? (
                <a href={info.url} className='hover:text-secondary' dir='ltr'>
                  {info.content}
                </a>
              ) : (
                <p className="whitespace-pre-line">{info.content}</p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default FooterContent
